import { render, staticRenderFns } from "./ChooseRedemptionFlow.vue?vue&type=template&id=05b202e6"
import script from "./ChooseRedemptionFlow.vue?vue&type=script&lang=js"
export * from "./ChooseRedemptionFlow.vue?vue&type=script&lang=js"
import style0 from "./ChooseRedemptionFlow.vue?vue&type=style&index=0&id=05b202e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports